/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Join_Notice_BodyInputs */

const en_us2_clubs_join_notice_body = /** @type {(inputs: Clubs_Join_Notice_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The club's admin decides these rules and may change them at any time, without another notice. If you don't agree with them, you can leave the club whenever you like.`)
};

const pt_br2_clubs_join_notice_body = /** @type {(inputs: Clubs_Join_Notice_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O admin do clube decide estas regras e pode mudá-las a qualquer momento, sem novo aviso. Se não concordar com elas, você pode sair do clube quando quiser.`)
};

const es_419_clubs_join_notice_body = /** @type {(inputs: Clubs_Join_Notice_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El admin del club define estas reglas y puede cambiarlas en cualquier momento, sin otro aviso. Si no estás de acuerdo, puedes salir del club cuando quieras.`)
};

const pt_pt2_clubs_join_notice_body = /** @type {(inputs: Clubs_Join_Notice_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O admin do clube decide estas regras e pode alterá-las a qualquer momento, sem novo aviso. Se não concordares com elas, podes sair do clube quando quiseres.`)
};

const fr_fr2_clubs_join_notice_body = /** @type {(inputs: Clubs_Join_Notice_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'admin du club fixe ces règles et peut les changer à tout moment, sans nouvel avis. Si tu n'es pas d'accord, tu peux quitter le club quand tu veux.`)
};

const de_de2_clubs_join_notice_body = /** @type {(inputs: Clubs_Join_Notice_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Admin des Clubs legt diese Regeln fest und kann sie jederzeit ohne erneuten Hinweis ändern. Wenn du nicht einverstanden bist, kannst du den Club jederzeit verlassen.`)
};

const it_it2_clubs_join_notice_body = /** @type {(inputs: Clubs_Join_Notice_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queste regole le decide l'admin del club e può cambiarle in qualsiasi momento, senza altro avviso. Se non sei d'accordo, puoi lasciare il club quando vuoi.`)
};

/**
* | output |
* | --- |
* | "The club's admin decides these rules and may change them at any time, without another notice. If you don't agree with them, you can leave the club whenever y..." |
*
* @param {Clubs_Join_Notice_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_join_notice_body = /** @type {((inputs?: Clubs_Join_Notice_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Join_Notice_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_join_notice_body(inputs)
	if (locale === "es-419") return es_419_clubs_join_notice_body(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_join_notice_body(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_join_notice_body(inputs)
	if (locale === "de-DE") return de_de2_clubs_join_notice_body(inputs)
	if (locale === "it-IT") return it_it2_clubs_join_notice_body(inputs)
	return en_us2_clubs_join_notice_body(inputs)
});
export { clubs_join_notice_body as "clubs.join_notice_body" }